<template>
  <div>
    <AboutBanner v-if="$route.path==='/sub/light-blocks/technical/calculator'" :content="banners[0].details"
                 :title="banners[0].title" :img="banners[0].photo_file"/>
    <div class="py-3">
      <AboutTitle :title="$t('calculator--ACC')" page-route="/sub/light-blocks" color="success"/>
      <v-container>
        <section style="min-height: 200px" class="cal-box mb-0 d-block">
          <v-row class="my-10">
            <v-col cols="12" xl="4" lg="4">
              <div class="field">
                <div class="field__title">{{ $t('enter-value') }}</div>
                <v-text-field
                    solo
                    hide-details
                    type="number"
                    v-model="inputNum"
                    height="50"
                    flat
                    dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" xl="4" lg="4">
              <div class="field">
              <div class="field__title">{{ $t('enter-unit') }}</div>
              <v-select
                  v-model="selectedUnit"
                  height="50"
                  dense
                  solo
                  hide-details
                  :items="unit"
              ></v-select>
              </div>
            </v-col>
            <v-col cols="12" xl="4" lg="4">
              <div class="field">
              <div class="field__title">{{ $t('enter-thickness') }}</div>
              <v-select
                  v-model="selectedThickness"
                  height="50"
                  dense
                  solo
                  hide-details
                  :items="blockThickness"
              ></v-select>
              </div>
            </v-col>
          </v-row>
          <div v-if="result" class="result-box">
            <v-container>

              <!--    <div v-for="(item,i) in cubicValues" :key="i">-->
              <!--     <div class="d-flex align-center">-->
              <!--       <h4>{{item.value}}</h4>-->
              <!--       <span v-if="item.value" class="mx-2">({{item.unit}})</span>-->
              <!--     </div>-->
              <!--    </div>-->
              <v-row>
                <v-col v-if="item.value" cols="6" v-for="(item,i) in cubicValues" :key="i">
                  <div class="d-flex align-center pa-3">
                    <h4>{{ parseFloat(item.value).toFixed(2) }}</h4>
                    <span v-if="item.value" class="mx-2">({{ item.unit }})</span>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <div class="text-center d-flex align-center justify-center mb-6">
            <v-btn style="border: 1px solid #000000 !important;"  class="px-16" @click="computing()" :disabled="inputNum==='' || selectedUnit==='' || selectedThickness===''"
                   depressed color="success">
              <h5 class="font-weight-bold black--text">{{ $t('process') }}</h5>
            </v-btn>
            <v-btn style="border: 1px solid #000000 !important;"  class="px-12" @click="reset()" :disabled="inputNum==='' || selectedUnit==='' || selectedThickness===''"
                   depressed color="success">
              <h5 class="font-weight-bold" style="color:black;">{{ $t('reset') }}</h5>
            </v-btn>

          </div>
        </section>

      </v-container>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import AboutBanner from "../pages/About/Components/AboutBanner";
import AboutTitle from "../../glass/pages/About/Components/AboutTitle";

export default {
  name: 'LightBlockLocalCalculator',
  components: {AboutTitle, AboutBanner},
  data() {
    return {
      inputNum: '',
      selectedUnit: '',
      selectedThickness: '',
      result: false,
      unit: ['متر مربع', 'متر مکعب', 'پالت', 'تریلی'],
      blockThickness: [8, 10, 12, 15, 20, 30],
      cubicValues: []
    }
  },
  methods: {
reset() {
  this.inputNum='';
      this.selectedThickness='';
      this.selectedUnit='';
      this.cubicValues=[];
      this.result=false;
},
    computing() {
      this.result = true;
      if (this.selectedUnit === 'متر مربع' && this.selectedThickness === 8) {
        var cubic = this.inputNum * 0.08;
        var pallet = (this.inputNum * 0.08) / 2.16;
        var trailer = this.inputNum / 459;
        var adhesive = (this.inputNum * 0.08) * 25;
        var radical = this.inputNum * 1;
        var holder = this.inputNum * 3;
      } else if (this.selectedUnit === 'متر مربع' && this.selectedThickness === 10) {
        cubic = this.inputNum * 0.10;
        pallet = (this.inputNum * 0.10) / 2.16;
        trailer = this.inputNum / 367;
        adhesive = (this.inputNum * 0.10) * 25;
        radical = this.inputNum * 1;
        holder = this.inputNum * 3;
      } else if (this.selectedUnit === 'متر مربع' && this.selectedThickness === 12) {
        cubic = this.inputNum * 0.12;
        pallet = (this.inputNum * 0.12) / 2.16;
        trailer = this.inputNum / 306;
        adhesive = (this.inputNum * 0.12) * 25;
        radical = this.inputNum * 1;
        holder = this.inputNum * 3;
      } else if (this.selectedUnit === 'متر مربع' && this.selectedThickness === 15) {
        cubic = this.inputNum * 0.15;
        pallet = (this.inputNum * 0.15) / 2.16;
        trailer = this.inputNum / 244;
        adhesive = (this.inputNum * 0.15) * 25;
        radical = this.inputNum * 1;
        holder = this.inputNum * 3;
      } else if (this.selectedUnit === 'متر مربع' && this.selectedThickness === 20) {
        cubic = this.inputNum * 0.20;
        pallet = (this.inputNum * 0.20) / 2.16;
        trailer = this.inputNum / 183;
        adhesive = (this.inputNum * 0.20) * 25;
        radical = this.inputNum * 1;
        holder = this.inputNum * 3;
      } else if (this.selectedUnit === 'متر مربع' && this.selectedThickness === 30) {
        cubic = this.inputNum * 0.30;
        pallet = (this.inputNum * 0.30) / 2.16;
        trailer = this.inputNum / 183;
        adhesive = (this.inputNum * 0.30) * 25;
        radical = this.inputNum * 1;
        holder = this.inputNum * 3;
      } else if (this.selectedUnit === 'متر مکعب' && this.selectedThickness === 8) {
        var square = this.inputNum * 0.08;
        pallet = this.inputNum / 2.16;
        trailer = this.inputNum / 36.72;
        adhesive = this.inputNum * 25;
        radical = (this.inputNum / 0.08);
        holder = (this.inputNum / 0.08) * 3;
      } else if (this.selectedUnit === 'متر مکعب' && this.selectedThickness === 10) {
        square = this.inputNum * 0.10;
        pallet = this.inputNum / 2.16;
        trailer = this.inputNum / 36.72;
        adhesive = this.inputNum * 25;
        radical = (this.inputNum / 0.10);
        holder = (this.inputNum / 0.10) * 3;
      } else if (this.selectedUnit === 'متر مکعب' && this.selectedThickness === 12) {
        square = this.inputNum * 0.12;
        pallet = this.inputNum / 2.16;
        trailer = this.inputNum / 36.72;
        adhesive = this.inputNum * 25;
        radical = (this.inputNum / 0.12);
        holder = (this.inputNum / 0.12) * 3;
      } else if (this.selectedUnit === 'متر مکعب' && this.selectedThickness === 15) {
        square = this.inputNum * 0.15;
        pallet = this.inputNum / 2.16;
        trailer = this.inputNum / 36.72;
        adhesive = this.inputNum * 25;
        radical = (this.inputNum / 0.15);
        holder = (this.inputNum / 0.15) * 3;
      } else if (this.selectedUnit === 'متر مکعب' && this.selectedThickness === 20) {
        square = this.inputNum * 0.20;
        pallet = this.inputNum / 2.16;
        trailer = this.inputNum / 36.72;
        adhesive = this.inputNum * 25;
        radical = (this.inputNum / 0.20);
        holder = (this.inputNum / 0.20) * 3;
      } else if (this.selectedUnit === 'متر مکعب' && this.selectedThickness === 30) {
        square = this.inputNum * 0.30;
        pallet = this.inputNum / 2.16;
        trailer = this.inputNum / 36.72;
        adhesive = this.inputNum * 25;
        radical = (this.inputNum / 0.30);
        holder = (this.inputNum / 0.30) * 3;
      } else if (this.selectedUnit === 'پالت' && this.selectedThickness === 8) {
        cubic = this.inputNum * 2.16;
        square = this.inputNum * 27;
        trailer = this.inputNum / 17;
        adhesive = (this.inputNum * 2.16) * 25;
        radical = (this.inputNum * 27);
        holder = (this.inputNum * 27) * 3;
      } else if (this.selectedUnit === 'پالت' && this.selectedThickness === 10) {
        cubic = this.inputNum * 2.16;
        square = this.inputNum * 21.6;
        trailer = this.inputNum / 17;
        adhesive = (this.inputNum * 2.16) * 25;
        radical = (this.inputNum * 21.6);
        holder = (this.inputNum * 21.6) * 3;
      } else if (this.selectedUnit === 'پالت' && this.selectedThickness === 12) {
        cubic = this.inputNum * 2.16;
        square = this.inputNum * 18;
        trailer = this.inputNum / 17;
        adhesive = (this.inputNum * 2.16) * 25;
        radical = (this.inputNum * 18);
        holder = (this.inputNum * 18) * 3;
      } else if (this.selectedUnit === 'پالت' && this.selectedThickness === 15) {
        cubic = this.inputNum * 2.16;
        square = this.inputNum * 14.4;
        trailer = this.inputNum / 17;
        adhesive = (this.inputNum * 2.16) * 25;
        radical = (this.inputNum * 14.4);
        holder = (this.inputNum * 14.4) * 3;
      } else if (this.selectedUnit === 'پالت' && this.selectedThickness === 20) {
        cubic = this.inputNum * 2.16;
        square = this.inputNum * 10.8;
        trailer = this.inputNum / 17;
        adhesive = (this.inputNum * 2.16) * 25;
        radical = (this.inputNum * 10.8);
        holder = (this.inputNum * 10.8) * 3;
      } else if (this.selectedUnit === 'پالت' && this.selectedThickness === 30) {
        cubic = this.inputNum * 2.16;
        square = this.inputNum * 7.2;
        trailer = this.inputNum / 17;
        adhesive = (this.inputNum * 2.16) * 25;
        radical = (this.inputNum * 7.2);
        holder = (this.inputNum * 7.2) * 3;
      } else if (this.selectedUnit === 'تریلی' && this.selectedThickness === 8) {
        cubic = this.inputNum * 36.72;
        pallet = this.inputNum / 17;
        square = this.inputNum * 459;
        adhesive = (this.inputNum * 36.72) * 25;
        radical = (this.inputNum * 459);
        holder = (this.inputNum * 459) * 3;
      } else if (this.selectedUnit === 'تریلی' && this.selectedThickness === 10) {
        cubic = this.inputNum * 36.72;
        pallet = this.inputNum / 17;
        square = this.inputNum * 367;
        adhesive = (this.inputNum * 36.72) * 25;
        radical = (this.inputNum * 367);
        holder = (this.inputNum * 367) * 3;
      } else if (this.selectedUnit === 'تریلی' && this.selectedThickness === 12) {
        cubic = this.inputNum * 36.72;
        pallet = this.inputNum / 17;
        square = this.inputNum * 306;
        adhesive = (this.inputNum * 36.72) * 25;
        radical = (this.inputNum * 306);
        holder = (this.inputNum * 306) * 3;
      } else if (this.selectedUnit === 'تریلی' && this.selectedThickness === 15) {
        cubic = this.inputNum * 36.72;
        pallet = this.inputNum / 17;
        square = this.inputNum * 244;
        adhesive = (this.inputNum * 36.72) * 25;
        radical = (this.inputNum * 244);
        holder = (this.inputNum * 244) * 3;
      } else if (this.selectedUnit === 'تریلی' && this.selectedThickness === 20) {
        cubic = this.inputNum * 36.72;
        pallet = this.inputNum / 17;
        square = this.inputNum * 183.6;
        adhesive = (this.inputNum * 36.72) * 25;
        radical = (this.inputNum * 183.6);
        holder = (this.inputNum * 183.6) * 3;
      } else if (this.selectedUnit === 'تریلی' && this.selectedThickness === 30) {
        cubic = this.inputNum * 36.72;
        pallet = this.inputNum / 17;
        square = this.inputNum * 122.4;
        adhesive = (this.inputNum * 36.72) * 25;
        radical = (this.inputNum * 122.4);
        holder = (this.inputNum * 122.4) * 3;
      }
      this.cubicValues = [
        {
          unit: 'مترمربع',
          value: radical
        },
        {
          unit: 'مترمکعب',
          value: cubic
        },
        {
          unit: 'پالت',
          value: pallet
        },
        {
          unit: 'تريلی',
          value: trailer
        },
        {
          unit: 'چسب مورد نياز(کيلوگرم)',
          value: adhesive
        },
        {
          unit: 'تعداد بست راديکالی مورد نياز',
          value: radical
        },
        {
          unit: 'تعداد بست تخت مورد نياز',
          value: holder
        },
      ]


    }
  },
  created() {
    if (this.banners == null) {
      this.$store.dispatch('lightBlocksManagement/getBlockBanners');
    }
  },
  computed: {
    ...mapState({
      banners: state => state.lightBlocksManagement.blockBanners,
    })
  }

}
</script>
<style scoped>
.cal-title {
  color: white;
  background-color: #7BAD32;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.cal-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  border-radius: 0;
}

.result-box {
  border: 1px solid #9e9e9e;
  min-height: 200px;
  width: 79%;
  border-radius: 9px;
  margin: auto auto 20px;
}

.field {

  border: 1px solid;
}

.field__title {
  color: black;
  padding: 8px 0;
  text-align: center;
  background-color: #7BAD32;
}

.v-text-field__details {
  display: none;
}
</style>